// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBh3cXQXKy52hVupec4lR11Xx2E_ypsqr4",
  // AIzaSyCJeNtdk-RrVYlOwNMQE-nZIf7f9YbXmf0 이전 코드드
  authDomain: "booking-6ec89.firebaseapp.com",
  projectId: "booking-6ec89",
  storageBucket: "booking-6ec89.firebasestorage.app",
  messagingSenderId: "727432660427",
  appId: "1:727432660427:web:9b1272fac935ab9ebbe24e",
  measurementId: "G-5JDWDL30FS",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
export const storage = getStorage(app);
